<template>
	<div id="zzjl" v-loading="loading">
		<div class="zzjl_main">
			<div class="query_info">
				<!-- 订单编号 -->
				<el-input v-model="orderNum" placeholder="请输入订单编号"></el-input>
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					placeholder="开始日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					placeholder="结束日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
				<el-button class="el-button--primary" @click="zzCxBtn">查询</el-button>
			</div>
			<div class="czTable">
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="OrderNumber" width="150" label="订单号" />
					<el-table-column prop="GameTypeText" label="平台" />
					<el-table-column prop="TranTypeText" label="账单类别" />
					<el-table-column prop="TranMoney" label="转账金额" />
					<el-table-column prop="AcountMoney" label="当前余额" />
					<el-table-column prop="CreateTime" label="操作时间" width="170" />
					<el-table-column prop="Remark" label="备注" />
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.png" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>

				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			//订单编号
			orderNum: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},
	mounted() {
		this.initDate();
		this.zzCxBtn();
	},
	methods: {
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.zzCxBtn();
		},
		//查询转账记录
		zzCxBtn() {
			let that = this;
			let url = "api/Transfer/GetTransferList";
			let zzData = {
				EndTime: this.endDate,
				OrderNumber: this.orderNum,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
				StartTime: this.beginDate,
				TranType: "",
			};
			this.loading = true;
			postAjax(url, zzData)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.zzCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
	},
};
</script>
<style type="scss">
#zzjl .zzjl_main {
	padding: 20px 0px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/zzjl.vue